import { PlayIcon } from "./icons";

interface Props {
  title: string;
  body?: string | undefined;
  spinner?: boolean | undefined;
  action?: { label: string; onClick: () => void; ghost?: boolean } | undefined;
  fine?: string | undefined;
}

/** Overlay shown on the stage whenever the avatar isn't live — the widget never renders as an empty frame. */
export function StatusCard({ title, body, spinner, action, fine }: Props) {
  return (
    <div class="wk-card" role="status">
      <div class={`wk-orb${spinner ? " spin" : ""}`} aria-hidden="true">{spinner ? <i /> : <PlayIcon />}</div>
      <h3>{title}</h3>
      {body && <p>{body}</p>}
      {action && (
        <button class={`wk-cta${action.ghost ? " ghost" : ""}`} onClick={action.onClick}>
          {action.label}
        </button>
      )}
      {fine && <span class="wk-fine">{fine}</span>}
    </div>
  );
}
